import React from "react";

import "../styles/dashboard.css";
import Title from "../components/Title";
import Pages from "../components/Pages";
import { SubscriptionGate } from "common/components/subscription/SubscriptionGate";
import useProfile from "profile/hooks/useProfile";

const DashboardPage = () => {

  return (
    <div className='dashboard-container'>
      <Title />
      <Pages />  
    </div>
  );
};

export default DashboardPage;
